import { render, staticRenderFns } from "./fruitsLaptopView.vue?vue&type=template&id=5b787fb8&scoped=true&"
import script from "./fruitsLaptopView.vue?vue&type=script&lang=js&"
export * from "./fruitsLaptopView.vue?vue&type=script&lang=js&"
import style0 from "./fruitsLaptopView.vue?vue&type=style&index=0&id=5b787fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b787fb8",
  null
  
)

export default component.exports